import React, {
    useContext, useCallback, useEffect, useState ,useLayoutEffect
} from 'react';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { commonMessages } from 'gw-capability-quoteandbind-common-react';
import metadata from './RiskAnalysisPage.metadata.json5';
import messages from './RiskAnalysisPage.messages';
import moment from 'moment';

function RiskAnalysisPage(props) {
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        wizardData, updateWizardData
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');

    const {
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate,
        registerComponentValidation
    } = useValidation('baRiskAnalysisPage');

    useEffect(() => {        
        submissionVM.baseData.priorLossHistoryRecords.forEach((item) => {return item.isValidationRequired.value = false} );
        submissionVM.baseData.hasUserVisitedRiskPage_EY.value = true;
    }, []);

    const addAdditionalInterest = useCallback(() => {
        const homeAdditionalInterests = _.get(
            submissionVM,
            'baseData.priorLossHistoryRecords'
        );

        homeAdditionalInterests.value = homeAdditionalInterests.value || [];
        const { _xCenter, _dtoName } = homeAdditionalInterests;
        const additionalVM = viewModelService.create({
            "productLine": submissionVM.baseData.productName.value,
            "source": "portal_ey"
        }, _xCenter, _dtoName);
        homeAdditionalInterests.pushElement(additionalVM);
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    }, [submissionVM, wizardData, updateWizardData, viewModelService]);

    const onModelChange = (updatedVM) => {
        const newSubmissionVM = viewModelService.clone(updatedVM);
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    }

    const removeAdditionalInterest = useCallback(
        (evt) => {
            const additionInterestPath = evt.path;
            const additionalInterestListPath = additionInterestPath.replace(
                /\.children\.\d+$/,
                '.value'
            );
            const additionalInterestToRemove = _.get(submissionVM, additionInterestPath);
            const additionalInterestList = _.get(submissionVM, additionalInterestListPath);

            ModalNextProvider.showConfirm({
                title: commonMessages.removeAdditionalInterest,
                message: commonMessages.removeAdditionalInterestDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.additionalModalYes,
                cancelButtonText: messages.additionalModalNo
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    const newAdditionalInterestList = additionalInterestList.filter(
                        (additionalInterest, index) => {
                            // eslint-disable-next-line
                            const additionalInterestListPathWithoutValue = additionalInterestListPath.replace(
                                '.value',
                                ''
                            );
                            const currentAdditionalInterestPath = `${additionalInterestListPathWithoutValue}.children.${index}`;
                            // eslint-disable-next-line
                            const isCorrectPath = currentAdditionalInterestPath === additionInterestPath;

                            return !(
                                isCorrectPath
                                && _.isEqual(additionalInterest, additionalInterestToRemove.value)
                            );
                        }
                    );

                    _.set(submissionVM, additionalInterestListPath, newAdditionalInterestList);
                    const newSubmissionVM = viewModelService.clone(submissionVM);
                    _.set(wizardData, 'submissionVM', newSubmissionVM);
                    updateWizardData(wizardData);
                    return true;
                }, _.noop
            );
        },
        [submissionVM, updateWizardData]
    );

    const additionalInterest = _.get(
        submissionVM,
        'baseData.priorLossHistoryRecords.value'
    );

    const overrideTitleProps = useCallback(() => {
        if (additionalInterest !== undefined) {
            const overrideProps = additionalInterest.map((value, index) => {
                
                const effectiveDate = moment(`${submissionVM.baseData.periodStartDate.year.value}-${submissionVM.baseData.periodStartDate.month.value +1}-${submissionVM.baseData.periodStartDate.day.value}`);
                let elmDate =  moment(`${value.lossDate.year}-${value.lossDate.month +1}-${value.lossDate.day}`);
                if(effectiveDate.diff(elmDate, 'days') <= 1095){
                    value.isValidationRequired = true;
                } else {
                    value.isValidationRequired = false; 
                }
                return {
                    // [`hoAdditionalInterest${index}`]: {
                    //     visible: index === 0
                    // },
                    [`hoAdditionalInterestCount${index}`]: {
                        //visible: index > 0,
                        content: translator(messages.additionalInterestDetailsCount, {
                            count: index + 1
                        })
                    },
                    [`lossLocation${index}`]: {
                        availableValues: submissionVM.baseData.policyLocations.value.map((c) => {
                            c['id'] = c.publicID;
                            return c
                        })
                    },
                    [`additionalInterestIterableContainer${index}`] :{
                        visible : effectiveDate.diff(elmDate, 'days') <= 1095
                    }
                };
            });

            return Object.assign({}, ...overrideProps);
        } else { return null }
    }, [additionalInterest, translator, submissionVM]);

    const onNext = useCallback(async () => {
        submissionVM.value = await EndorsementService.saveEndorsement(
            [submissionVM.value],
            authHeader
        );
        return wizardData;
    }, [EndorsementService, authHeader, submissionVM, wizardData]);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        // hoAddAnotherAdditionalInterest: {
        //     visible: additionalInterest !== undefined ? additionalInterest.length > 0 : false
        // },
        hoAddAdditionalInterest: {
            visible: additionalInterest !== undefined ? additionalInterest.length > 0 : false
        },
        contentEmptyContainer:{
            visible: additionalInterest !== undefined ? additionalInterest.length == 0 : true
        },
        ...overrideTitleProps()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddAdditionalInterest: addAdditionalInterest,
            onRemoveAdditionalInterest: removeAdditionalInterest
        }
    };

    return (
        <WizardPage onNext={onNext} disableNext={!isComponentValid} skipWhen={initialValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={onModelChange}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

RiskAnalysisPage.propTypes = wizardProps;
export default RiskAnalysisPage;
